module.exports = __webpack_public_path__ + "img/continents-medium.92288d42.png";